import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconElinformador from '../build/icon-elinformador'

export const IconElInformador: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconElinformador} />
}

export default IconElInformador
